import { render } from "./AboutContentBlock.vue?vue&type=template&id=36a7516c&scoped=true&ts=true"
import script from "./AboutContentBlock.vue?vue&type=script&lang=ts"
export * from "./AboutContentBlock.vue?vue&type=script&lang=ts"

import "./AboutContentBlock.vue?vue&type=style&index=0&id=36a7516c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a7516c"]])

export default __exports__